<template>
  <v-card v-if="identifyResults">

    <v-card-text class="py-1">

      <div class="d-flex align-center">
        <h5 class="primary--text title">
          Service Areas At Location
        </h5>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="pointZoom">
          <v-icon>mdi-magnify-plus</v-icon>
        </v-btn>
        <v-btn small icon @click.stop="handleCardClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

    </v-card-text>

    <v-card-text class="pt-0 pb-1">

      <v-scale-transition>

        <ServiceAreasTable
          v-if="identifyResults.length"
          :items="identifyResults"
          :blacklist="['isSelected', 'properties.County']"
          :sort-by="['properties.Speeds_mbps']"
          :sort-desc="[true]"
          hide-default-footer
          :dense="false"
          disable-pagination
          @row-clicked="handleRowClick"
        >

        </ServiceAreasTable>

        <v-alert v-else type="warning" border="top">
          No services found at this location.
        </v-alert>

      </v-scale-transition>

    </v-card-text>
  </v-card>
</template>

<script>
import ServiceAreasTable from '../tables/ServiceAreasTable';

export default {

  components: { ServiceAreasTable, },

  data: () => ({}),

  computed: {

    identifyResults() {
      return this.$store.state.data.identifyResults;
    },

  },

  watch: {

    '$store.state.mapping.selectedService'(service) {
      this.handleRowClick(service);
    },

  },

  methods: {
    handleCardClose() {
      this.$emit('close');
    },
    handleFeatureZoom() {
      this.$emit('feature-zoom');
    },
    handleRowClick(row) {
      this.$emit('close');
      // this.$emit('service-result-clicked', row);
      this.$router.push({
        name: 'provider-detail',
        params: {
          id: row.properties.ProviderID,
        },
        query: {
          service: row.id,
        },
      });
    },
    pointZoom() {
      this.$emit('point-zoom');
    },
  },

};
</script>

<style lang="scss">



</style>
